import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultButton from 'components/Utils/NewDefaultButton';
import Icon from 'components/Utils/NewIcon';
import IconButton from '@material-ui/core/IconButton';
import TaskEditModal from 'components/Tasks/Utils/TaskEditModal';

const NewTaskButton = (props) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="new-task-button">
      {props.plainText ? (
        <span onClick={() => setShowModal(true)}>Add New Task</span>
      ) : (
        <>
          {!props.hideName && (
            <DefaultButton
              name="Add New Task"
              icon="circle-check"
              onClick={() => setShowModal(true)}
              style={{ zIndex: '100' }}
            />
          )}
          {props.hideName && (
            <IconButton onClick={() => setShowModal(true)}>
              <Icon width="20px" showTooltip={true} alt="Add New Task" src="circle-check" />
            </IconButton>
          )}
        </>
      )}
      {showModal && (
        <TaskEditModal
          editModal={showModal}
          task={props.task}
          openEditModal={setShowModal}
          patient={props.patient}
          staff={props.staff}
          showPatient={!props.patient}
        />
      )}
    </div>
  );
};

NewTaskButton.propTypes = {
  patient: PropTypes.object,
  staff: PropTypes.object,
  hideName: PropTypes.bool,
  task: PropTypes.object,
};

export default NewTaskButton;
